<script setup lang="ts">
// «Резюме vs видео»: the divider follows the page scroll until the visitor drags it.
import { testimonials } from './landing-content'
import LandingVideo from './LandingVideo.vue'

const split = ref(50)
const dragged = ref(false)

const root = useTemplateRef<HTMLElement>('root')
let dragging = false

function set(value: number) {
  dragged.value = true
  split.value = Math.min(95, Math.max(5, value))
}

function onPointer(event: PointerEvent) {
  if (event.type === 'pointerdown') dragging = true
  if (!dragging || !root.value) return
  const rect = root.value.getBoundingClientRect()
  set(((event.clientX - rect.left) / rect.width) * 100)
}
</script>

<template>
  <div
    ref="root"
    class="landing-split relative aspect-[4/5] w-full cursor-ew-resize touch-pan-y overflow-hidden rounded-3xl bg-neutral-100 shadow-xl ring-1 ring-border select-none sm:aspect-[16/10]"
    :class="dragged ? '' : 'landing-split-auto'"
    :style="dragged ? { '--split': `${split}%` } : undefined"
    @pointerdown="onPointer"
    @pointermove="onPointer"
    @pointerup="dragging = false"
    @pointercancel="dragging = false"
    @pointerleave="dragging = false"
  >
    <div class="absolute inset-0 p-5 text-neutral-500 sm:p-8">
      <p class="text-xs font-semibold uppercase tracking-[0.14em] text-neutral-400">Обычное резюме</p>
      <p class="mt-3 text-xl font-bold text-neutral-700">Орлова Варвара</p>
      <p class="text-sm">Желаемая должность: официант</p>
      <div class="mt-5 space-y-4 text-sm">
        <div>
          <p class="font-semibold text-neutral-600">Опыт работы</p>
          <p>Нет</p>
        </div>
        <div>
          <p class="font-semibold text-neutral-600">Навыки</p>
          <p>Коммуникабельность, стрессоустойчивость, быстро обучаюсь, ответственность</p>
        </div>
        <div>
          <p class="font-semibold text-neutral-600">О себе</p>
          <p>Пунктуальная, исполнительная, умею работать в команде…</p>
        </div>
        <div class="space-y-2 pt-2" aria-hidden="true">
          <div class="h-2.5 w-11/12 rounded bg-neutral-200" />
          <div class="h-2.5 w-4/5 rounded bg-neutral-200" />
          <div class="h-2.5 w-2/3 rounded bg-neutral-200" />
        </div>
      </div>
    </div>

    <div class="landing-split-after absolute inset-0 bg-black text-white">
      <LandingVideo :src="testimonials[6]!.src" class="absolute inset-0 size-full object-cover" />
      <div class="absolute inset-0 bg-linear-to-t from-black/80 via-transparent to-black/30" />
      <p class="absolute right-5 top-5 text-xs font-semibold uppercase tracking-[0.14em] text-white/80 sm:right-8 sm:top-8">Видеорезюме на Sobes</p>
      <div class="absolute bottom-5 right-5 text-right sm:bottom-8 sm:right-8">
        <p class="text-xl font-bold">Варвара, 19</p>
        <p class="text-sm text-white/80">«Без опыта — нашла работу через 2 дня»</p>
      </div>
    </div>

    <div class="landing-split-handle pointer-events-none absolute inset-y-0 w-1 -translate-x-1/2 bg-white shadow-[0_0_20px_rgb(0_0_0/40%)]">
      <span class="absolute left-1/2 top-1/2 flex size-11 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-white text-neutral-900 shadow-lg">
        <Icon name="tabler:arrows-horizontal" class="size-5" />
      </span>
    </div>
    <input
      type="range"
      min="5"
      max="95"
      :value="split"
      aria-label="Сравнить резюме и видео"
      class="sr-only"
      @input="set(Number(($event.target as HTMLInputElement).value))"
    >
  </div>
</template>

<style scoped>
@property --split {
  syntax: '<percentage>';
  inherits: true;
  initial-value: 50%;
}

.landing-split-after {
  clip-path: inset(0 0 0 var(--split));
}

.landing-split-handle {
  left: var(--split);
}

@keyframes landing-split {
  from { --split: 88%; }
  to { --split: 22%; }
}

@supports (animation-timeline: view()) {
  @media (prefers-reduced-motion: no-preference) {
    .landing-split-auto {
      animation: landing-split linear both;
      animation-timeline: view();
      animation-range: entry 40% exit 10%;
    }
  }
}
</style>
